import { render, staticRenderFns } from "./GenerateTreatment.vue?vue&type=template&id=13e0d024&scoped=true"
import script from "./GenerateTreatment.vue?vue&type=script&lang=js"
export * from "./GenerateTreatment.vue?vue&type=script&lang=js"
import style0 from "./GenerateTreatment.vue?vue&type=style&index=0&id=13e0d024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e0d024",
  null
  
)

export default component.exports